import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OrderService, WorksheetProduct } from '../services/order.service';
import { ProjectService } from '../../api/services/project.services';
import { MarketService } from '../../api/services/market.service';
import { Address } from '../../api/models/address';
import { NgbModal, NgbActiveModal, NgbTypeaheadSelectItemEvent, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AddressCreationComponent } from '../address-creation/address-creation.component';
import { Worksheet } from '../../api/models/worksheet';
import { Router } from '@angular/router';
import { PreferencesService } from '../../api/services/preferences.service';
import { AuthService } from '../../api/services/auth.service';
import { Team } from '../../api/models/team';
import { UserService } from '../../api/services/user.service';
import { map } from 'rxjs/operators';
import { Project } from '../../api/models/project-model';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { MarketTeamUserDetailsByType, MarketPermissionDetails, Market } from '../../api/models/market-model';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { BomLinesRequest, BomLine } from '../../api/models/bom-line';
import { ProductAliasService } from '../../api/services/product-alias.service';
import { Product } from '../../api/models/product';
import { AnalyticsService } from '../../api/services/analytics.service';

interface ContractorTeamOptions {
  teamId: string,
  teamName: string,
  teamSelected: boolean
}

@Component({
  selector: 'app-order-create',
  templateUrl: './order-create.component.html',
  styleUrls: ['./order-create.component.scss']
})
export class OrderCreateComponent implements OnInit {

  private VERIZON_DATE_FORMAT_REGEX = '(0[1-9]|1[012])/(0[1-9]|[12][0-9]|3[01])/([0-9]{2})';
  userIds = [];

  worksheet: Worksheet;

  orderForm: FormGroup;
  shipInfoForm: FormGroup;

  addressSelected: Address;
  addressSelectedId: string;

  project: Project;

  selectedTeam: Team;
  approvalSelectedTeamId: string;
  contractorTeams: Team[];
  contractorTeamType: number = 2;
  initiatorTeams: MarketPermissionDetails[];
  selectedInitiatorTeam: MarketPermissionDetails;
  savingWorksheet = false;
  orderError = false;
  err: any;
  errMsg: string[] = [];

  actiton: string;

  loading = true;
  canCreateAddress = false;

  contractorTeamOptions : ContractorTeamOptions[];
  initiatorTeamOptions: ContractorTeamOptions[];

  approvers: {id: string, isSelected: boolean, requestor: string, name: string}[] = [];
  selectedApprover: {id: string, isSelected: boolean, requestor: string, name: string};
  specialSelected: string;
  tbdAddress: boolean = false;
  roleRequest: RoleRequest;
  specialChars = "{ } > | < ` ~ [ ] # % ^ ' \" / \\";

  isVerizon: boolean = false;
  isInitiator: boolean = false;
  isAdmin: boolean = false;
  shortName: string;
  initiatorTeamId: string;
  initiatorTeamName: string;
  emailIdList :string[];
  invalidEmailErrorMessage : boolean = false;
  minDate: NgbDateStruct;
  constructor(
    private formBuilder: FormBuilder,
    private orderService: OrderService,
    private projectService: ProjectService,
    private marketService: MarketService,
    private modalService: NgbModal,
    private router: Router,
    private preferencesService: PreferencesService,
    private authService: AuthService,
    private userService: UserService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private productAliasService: ProductAliasService,
    private analyticsService: AnalyticsService
  ) { }

  private onOrderSubscription(addressdId: string) {
    if (addressdId) {
      this.marketService.getAddress(this.project.marketId, addressdId).subscribe(address => {
        this.addressSelected = address;
        this.setFormData();
      });
    } else {
      this.addressSelectedId = '1';
      this.addressSelected = new Address();
      this.setTbdAddress();
      this.setFormData();
    }
  }

  private setFormData() {
    let date = new Date(this.worksheet.requestedDeliveryDate);
    let pattern = '^[^\u{0080}-\u{FFFF}\\\[\\\]\\\\\'\"/{`~#%<|>^}]+$';

    if (date < new Date()) {
      if (this.specialSelected === 'Verizon eQuote') {
        this.errMsg.push("Est. Need-By-Date has to be a date in the future.");
      } else {
        this.errMsg.push("Target Delivery Date has to be a date in the future.");
      }
    }

    this.orderForm = this.formBuilder.group({
      siteName: [this.worksheet.siteName, Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern(pattern)])],
      siteNumber: ['0000'],
      targetDeliveryDate: [date, Validators.required]
    });

    this.shipInfoForm = this.formBuilder.group({
      id: [this.addressSelected.id],
      line1: [this.addressSelected.line1, Validators.required],
      line2: [this.addressSelected.line2],
      line3: [this.addressSelected.line3],
      companyName: [this.addressSelected.companyName, Validators.required],
      locationCode: [this.addressSelected.locationCode],
      city: [this.addressSelected.city, Validators.required],
      state: [this.addressSelected.state, Validators.required],
      zip: [this.addressSelected.zip, Validators.required],
      contactName: [this.addressSelected.contactName],
      contactPhone: [this.addressSelected.contactPhone],
      acceptBulk: [this.addressSelected.acceptBulk],
      acceptParcel: [this.addressSelected.acceptParcel],
      requiresLiftGate: [this.addressSelected.requiresLiftGate],
      addressSearchText: [''],
      tbdAddress: [this.tbdAddress]
    });
    this.shortName = this.addressSelected.locationName;
    if (this.worksheet.id &&
      this.worksheet.emailIds != null && this.worksheet.emailIds.length > 0) {
      let emailIdArrays = this.worksheet.emailIds.split(',');
      this.emailIdList = emailIdArrays;
    }
    this.loading = false;
  }

  addressChange(newAddress: Address) {
    this.addressSelected = newAddress;
    if (newAddress) {
      if (!newAddress.id) {
        this.addressSelectedId = '1';
      } else {
        this.addressSelectedId = newAddress.id;
      }
      if (this.shipInfoForm) {
        this.shipInfoForm.patchValue(newAddress);
        this.shipInfoForm.get('addressSearchText').setValue(this.addressFormatter(newAddress));
      }
    }
  }

  saveMarketAddress() {
    let oldLine2Value = this.addressSelected.line2;
    let newLine2Value = this.shipInfoForm.value.line2.trim();
    let oldLine3Value = this.addressSelected.line3;
    let newLine3Value = this.shipInfoForm.value.line3.trim();

    if (oldLine2Value != newLine2Value || oldLine3Value != newLine3Value) {
      this.addressSelected.line2 = newLine2Value;
      this.addressSelected.line3 = newLine3Value;
      this.marketService.saveAddress(this.project.marketId, this.addressSelected).subscribe(address => {
        this.onUpdateSuccess('Market address updated successfully!!');
      }, error => {
        this.onErrorAction(error);
      });
    }
  }

  private onUpdateSuccess(message: string) {
    this.toastr.success(message, 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  saveWorksheet() {
    this.orderForm.controls['siteName'].setValue(this.orderForm.value['siteName'].trim());
    this.orderForm.controls['siteName'].updateValueAndValidity();
    if (this.orderForm.valid) {
      this.savingWorksheet = true;
      this.errMsg = [];
      if (this.addressSelectedId !== '1') {
        this.worksheet.shipToAddressId = this.addressSelectedId;
        this.worksheet.confirmedShipToAddressId = true;
        this.saveMarketAddress();
      } else {
        this.worksheet.shipToAddressId = null;
        this.worksheet.confirmedShipToAddressId = false;
      }
      this.worksheet.projectId = this.project.id;
      this.worksheet.siteName = this.orderForm.getRawValue().siteName;
      this.worksheet.siteNumber = this.orderForm.getRawValue().siteNumber;
      this.worksheet.contractorId = this.selectedTeam ? this.selectedTeam.id : null;
      this.worksheet.contractorTeamName = this.selectedTeam ? this.selectedTeam.name : null;

      if (this.orderForm.getRawValue().targetDeliveryDate) {
        let date = this.orderForm.getRawValue().targetDeliveryDate;
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        this.worksheet.requestedDeliveryDate = date;
        this.worksheet.confirmedNeedByDate = true;
      } else {
        let date = new Date(this.project.deliveryDate);
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        this.worksheet.requestedDeliveryDate = this.datepipe.transform(date, 'yyyy-MM-ddT00:00:00.000Z');
        this.worksheet.confirmedNeedByDate = false;
      }
      let atcApproverId = this.selectedApprover ? this.selectedApprover.id : null;
      let atcApproverName = this.selectedApprover ? this.selectedApprover.requestor : null;
      if (this.isInitiator) {
        this.worksheet.initiatorTeamId = this.initiatorTeamId;
        this.worksheet.initiatorTeamName = this.initiatorTeamName;
      } else {
        this.worksheet.initiatorTeamId = this.selectedInitiatorTeam ? this.selectedInitiatorTeam.id : null;
        this.worksheet.initiatorTeamName = this.selectedInitiatorTeam ? this.selectedInitiatorTeam.name : null;
      }
      let emailIdsString = this.emailIdList ? this.emailIdList.join() : '';
      this.worksheet.emailIds = emailIdsString;
      if (!atcApproverId) {
        this.approverNameIsEmpty();
      } else {
        this.worksheet.atcApproverId = atcApproverId;
        this.worksheet.atcApproverName = atcApproverName;
        this.worksheet.id ? this.updateWorksheet() : this.createWorksheet();
      }
    }
  }

  dateSelected(event) {
    this.removeDateSelectedErrorMessage();
  }

  removeDateSelectedErrorMessage() {
    this.errMsg = this.errMsg.filter(errMessage =>
      errMessage !== "Est. Need-By-Date has to be a date in the future." &&
      errMessage !== "Target Delivery Date has to be a date in the future.");
  }

  approverNameIsEmpty() {
    this.savingWorksheet = false;
    this.orderError = true;
    this.errMsg.push("Worksheet approver name is required.");
  }

  updateWorksheet() {
    this.projectService.updateWorksheet(this.worksheet.id, this.worksheet).subscribe(worksheet => {
      this.activeModal.close();
      this.projectService.refreshWorksheet.next(true);
    }, error => {
      this.onErrorAction(error);
    });
  }

  createWorksheet() {
    this.projectService.createWorksheet(this.worksheet).subscribe(worksheet => {
      this.userIds.forEach(user => {
        this.projectService.addShipmentNotificationUser(user.value, worksheet.id).subscribe();
      });
      //below if condition is used while creating worksheet for global search sku
      const worksheetProducts = this.orderService.getWorksheetProducts();
      if (worksheetProducts.length) {
        worksheetProducts.forEach(worksheetProduct => {
          this.productAliasService.productDetailsV2([worksheetProduct.partNumber], localStorage.getItem('marketAccountNo'), '', true).subscribe(products => {
            const product = products[0];
            const bomLineRequest = this.getBomLineRequest(worksheet, worksheetProduct, product);
            this.projectService.createBomLinesV2(bomLineRequest).subscribe(bomLines => {
              this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-worksheet', worksheet.id] } }]);
              this.activeModal.close();
            });
          });
        });
      } else {
        this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-worksheet', worksheet.id] } }]);
        this.activeModal.close();
      }
     this.sendDataToAnalytics(worksheet);
    }, error => {
      this.onErrorAction(error);
    });
  }

  private sendDataToAnalytics(worksheet: Worksheet) {
    this.analyticsService.trackWorksheetCreate(worksheet.siteName);
  }

  private getBomLineRequest(worksheet: Worksheet, worksheetProduct: WorksheetProduct, product: Product) {
    const bomLineRequest = new BomLinesRequest();
    bomLineRequest.bomId = worksheet.bomId;
    bomLineRequest.worksheetId = worksheet.id;
    bomLineRequest.customerNumber = localStorage.getItem('marketAccountNo');;
    const bomLine = new BomLine();
    bomLine.partNumber = worksheetProduct.partNumber;
    if (worksheetProduct.qty < product.minimumQuantity) {
      worksheetProduct.qty = product.minimumQuantity;
    }
    bomLine.quantity = worksheetProduct.qty;
    bomLine.isCableItem = product.isCableItem;
    bomLine.isConsignmentItem = product.isConsignedItem;
    bomLineRequest.bomLines = [bomLine];
    return bomLineRequest;
  }

  onErrorAction(error: any) {
    this.savingWorksheet = false;
    this.orderError = true;
    this.err = error.error;
    this.errMsg.push(error.error.message);
  }

  addAddress(addressName: string) {
    const modalRef = this.modalService.open(AddressCreationComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.addressName = addressName;
    modalRef.componentInstance.flag = true;
    modalRef.result.then((address) => {
      this.addressChange(address);
    }).catch(() => {
      //Empty catch block
    });
  }

  teamChange(id: string) {
    this.selectedTeam = this.contractorTeams.filter(t => t.id === id)[0];
  }

  onApproverChange(id: string) {
    this.selectedApprover = this.approvers.filter(a => a.id === id)[0];
    if (this.selectedApprover && this.selectedApprover.id) {
      this.removeApproverSelectedMessage();
    }
  }

  removeApproverSelectedMessage() {
    this.errMsg = this.errMsg.filter(errMessage => errMessage != "Worksheet approver name is required.");
  }

  onInitiatorChange(id: string) {
    this.selectedInitiatorTeam = this.initiatorTeams.filter(a => a.id === id)[0];
  }

  autocompleteUsers = (text: string) => {
    return this.userService.findUserByOrganizationIdAndText(this.project.organizationId, text)
      .pipe(map(data => data.map(user => [`${user['First Name']} ${user['Last Name']}`, user['User ID']])));
  }

  ngOnInit() {
    this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
      this.isAdmin = user.isAdmin;
      if (user["Team ID"]) {
        this.authService.getTeamById(user["Team ID"]).subscribe(team => {
          if (team.type === 0) {
            this.initiatorTeamId = team.id;
            this.initiatorTeamName = team.name;
            this.isInitiator = true;
          }
        });
      }
    });
    var today = new Date();
    this.minDate = { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };

    if (this.worksheet.id) {
      this.addressSelectedId = this.worksheet.shipToAddressId;
      this.onOrderSubscription(this.addressSelectedId);
    } else {
      this.preferencesService.getPreferences('PROJECT', this.project.id).subscribe(projectPrefs => {
        this.addressSelectedId = projectPrefs['site-address'].Value;
        if (!this.addressSelectedId) {
          this.preferencesService.getPreferences('MARKET', this.project.marketId).subscribe(marketPrefs => {
            this.addressSelectedId = marketPrefs['default-address'].Value;
            this.onOrderSubscription(this.addressSelectedId);
          });
        } else {
          this.onOrderSubscription(this.addressSelectedId);
        }
      });
    }

    this.preferencesService.getPreferences('CUSTOMER', this.project.organizationId).subscribe(prefs => {
      this.specialSelected = prefs['special-fields'].Value;
      if (this.specialSelected !== 'ATC') {
        this.isVerizon = true;
        this.userService.getVerizonApproversByOrgIdMarketId(this.project.organizationId, this.project.marketId).subscribe(users => {
          if (users) {
            users.forEach(user => this.approvers.push({ id: user['User ID'], isSelected: false, requestor: user['First Name'] + ' ' + user['Last Name'], name: user['First Name'] + ' ' + user['Last Name'] }));
            const selected = this.approvers.find(approver => approver.id === this.worksheet.atcApproverId);
            if (selected) {
              selected.isSelected = true;
              this.selectedApprover = selected
            }
          }
        });
        let requestVariable = new MarketTeamUserDetailsByType(this.project.marketId, 'USER_GROUP', 0);
        this.marketService.getMarketPermissionDetailsByType(requestVariable).subscribe(response => {
          this.initiatorTeams = response.permissionDetails;
          if (this.initiatorTeams) {
            this.initiatorTeamOptions = [];
            this.initiatorTeams.forEach(team => {
              this.initiatorTeamOptions.push({ teamId: team.id, teamName: team.name, teamSelected: (team.id === this.worksheet.initiatorTeamId) });
            });
            if (this.worksheet.initiatorTeamId && !this.selectedInitiatorTeam) {
              this.selectedInitiatorTeam = this.initiatorTeams.find(team => team.id === this.worksheet.initiatorTeamId);
            }
          }
        });
      } else if (this.specialSelected === 'ATC') {
        this.userService.getAllAtcApprovers(this.project.marketId).subscribe(approvers => {
          if (approvers) {
            approvers.forEach(approver => this.approvers.push({ id: approver.id, isSelected: false, requestor: approver.requestor, name: approver.name }));
            const selected = this.approvers.find(approver => approver.id === this.worksheet.atcApproverId);
            if (selected) {
              selected.isSelected = true;
              this.selectedApprover = selected
            }
          }
        });
      } else {
        if (this.project.inheritMarketPermissions) {
          this.marketService.getMarketById(this.project.marketId).subscribe(mkt => {
            let market: Market = mkt;
            let approverUserIds: string[] = [];
            let approverTeamIds: string[] = [];
            if (market && market.marketPermissions && market.marketPermissions.length) {
              market.marketPermissions.forEach(permission => {
                if (!permission.isAdmin && permission.roleType == '1') {
                  const isTeam = this.getTargetType(permission.target) === 'USER_GROUP';
                  if (isTeam) {
                    this.pushUniqueValueToStringArray(this.getTargetId(permission.target), approverTeamIds);
                  } else {
                    this.pushUniqueValueToStringArray(this.getTargetId(permission.target), approverUserIds);
                  }
                }
              });
              if (approverTeamIds.length) {
                this.authService.getActiveUsersOfGroups(approverTeamIds).subscribe(results => {
                  if (results && results.length) {
                    this.addUniqueApproverUsers(results);
                  }
                }, error => {
                  //Empty error block
                });
              }

              if (approverUserIds.length) {
                this.addUniqueApproverUsers(approverUserIds);
              }
            }
          }, error => {
            //Empty error block
          });
        } else {
          let approverUserIds: string[] = [];
          let approverTeamIds: string[] = [];
          if (this.project && this.project.projectPermissions && this.project.projectPermissions.length) {
            this.project.projectPermissions.forEach(permission => {
              if (!permission.isAdmin && permission.roleType == '1') {
                const isTeam = this.getTargetType(permission.target) === 'USER_GROUP';
                if (isTeam) {
                  this.pushUniqueValueToStringArray(this.getTargetId(permission.target), approverTeamIds);
                } else {
                  this.pushUniqueValueToStringArray(this.getTargetId(permission.target), approverUserIds);
                }
              }
            });
            if (approverTeamIds.length) {
              this.authService.getActiveUsersOfGroups(approverTeamIds).subscribe(results => {
                if (results && results.length) {
                  this.addUniqueApproverUsers(results);
                }
              }, error => {
                //Empty error block
              });
            }

            if (approverUserIds.length) {
              this.addUniqueApproverUsers(approverUserIds);
            }
          }
        }
      }
    });

    if (this.project.inheritMarketPermissions) {
      this.roleRequest = new RoleRequest('ADDRESS_CREATE', `MARKET~${this.project.marketId}`);
    } else {
      this.roleRequest = new RoleRequest('ADDRESS_CREATE', `PROJECT~${this.project.id}`);
    }
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.canCreateAddress = roles.getRoleMap('ADDRESS_CREATE');
    });

    this.authService.getTeamsByMarketId(this.project.marketId).subscribe(teams => {
      this.contractorTeams = teams.filter(team => team.type === 2);
      if (this.contractorTeams) {
        this.authService.getUserTeamByType(this.authService.getUserId(), this.contractorTeamType).subscribe(team => {
          if (team.type != undefined && team.type != null && team.type === this.contractorTeamType) {
            this.contractorTeams = this.contractorTeams.filter(contractorTeam => contractorTeam.name === team.name);
            return true;
          }
          this.contractorTeamOptions = [];
          const contractorTeamSize = this.contractorTeams.length;
          this.contractorTeams.forEach(team => {
            if (contractorTeamSize == 1) {
              this.contractorTeamOptions.push({ teamId: team.id, teamName: team.name, teamSelected: true });
              this.selectedTeam = team;
            } else {
              this.contractorTeamOptions.push({ teamId: team.id, teamName: team.name, teamSelected: (team.id === this.worksheet.contractorId) });
            }
          });
          if (this.worksheet.contractorId && !this.selectedTeam) {
            this.selectedTeam = this.contractorTeams.find(team => team.id === this.worksheet.contractorId);
          }
        });
      }
    });
  }

  get line1() { return this.shipInfoForm.get('line1'); }
  get state() { return this.shipInfoForm.get('state'); }
  get zip() { return this.shipInfoForm.get('zip'); }
  get city() { return this.shipInfoForm.get('city'); }

  getTargetId(target: string): string {
    return target.split('~')[1];
  }

  getTargetType(target: string): string {
    return target.split('~')[0];
  }

  pushUniqueValueToStringArray(value: string, arr: string[]) {
    if (!arr.includes(value)) {
      arr.push(value);
    }
  }

  addUniqueApproverUsers(approverUserIds: string[]) {
    this.userService.getUsersWithPermission(approverUserIds.join(",")).subscribe(users => {
      if (users && users.length) {
        users.forEach(u => {
          if (this.approvers && this.approvers.filter(a => a.id === u['User ID']).length <= 0) {
            this.approvers.push({ id: u['User ID'], isSelected: false, requestor: u['First Name'] + " " + u['Last Name'], name: u['First Name'] + " " + u['Last Name'] });
          }
        })
      }
    }, error => {
      //Empty error block
    });
  }

  setTbdAddress() {
    this.tbdAddress = !this.tbdAddress;
    if (this.tbdAddress) {
      this.removeAddress();
    }
  }

  addressFormatter = (entity: Address) => {
    return entity.id ? `${entity.locationName}` : '';
  }

  addressFormatterResult = (entity: Address) => {
    return entity.id ? `${entity.locationName} - ${entity.line1}, ${entity.city}, ${entity.state}` : '';
  }

  addressSearch = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .switchMap(term =>
        !term ? of([]) : this.marketService.findAddressesByText(this.project.marketId, term)
          .map(results => results.concat([new Address()]))
          .catch(err => {
            return of([]);
          })
      );

  onAddressSelected($event: NgbTypeaheadSelectItemEvent, alias: HTMLInputElement) {
    if (!$event.item.id) {
      $event.item.alias = alias.value;
      alias.value = null;
      $event.preventDefault();
    }
    this.addressSelected = $event.item;
    this.addressChange(this.addressSelected);
  }

  removeAddress() {
    this.addressSelected = new Address();
    this.addressChange(this.addressSelected);
  }

  onEnteringEmailAddress(event: any) {
    let enteredEmail = event.target.value;
    if (enteredEmail === undefined || enteredEmail == '') {
      this.invalidEmailErrorMessage = false;
    } else {
      if (this.validateEmail(enteredEmail)) {
        this.invalidEmailErrorMessage = false;
      } else {
        this.invalidEmailErrorMessage = true;
      }
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  closeErrorMessage() {
    this.errMsg = [];
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-create/order-create.component.ts